import React from 'react'
import { target } from '~target'

const Component = target == 'extension' ?
	require('./extension').default :
	require('./fallback').default

const BookmarksAddWrap = React.memo(function BookmarksAddWrap({
	spaceId = 0,
	onEdit = undefined,
	...etc
}) {
	return <Component spaceId={spaceId} onEdit={onEdit} {...etc} />
})

export default BookmarksAddWrap
